import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { hideModal, displayModal } from '@store/appStateSlice';
import content from './PaymentError.json';
import {
  ModalWrap,
  Title,
  ErrorText,
  ButtonGrid,
  DarkButton,
  LightButton,
} from './PaymentError.styles';
import { getLanguagePrefix } from '@helpers';
import { getLocalizedContent as l } from '@helpers/languages';

const PaymentError = ({ configurationData }) => {
  const dispatch = useDispatch();
  const { language, prefixLanguage } = useSelector(({ appState }) => appState);

  const handleRefresh = () => {
    if (typeof window !== `undefined`) {
      window.location.href = `${getLanguagePrefix(
        prefixLanguage
      )}/portal/designs/`;
    }
  };

  const handleContact = () => {
    dispatch(hideModal());

    setTimeout(() => {
      dispatch(
        displayModal({
          modalName: 'CONTACT',
          modalProps: { configurationData },
        })
      );
    }, 500);
  };

  return (
    <ModalWrap>
      <Title>{l(content.title, language)}</Title>
      <ErrorText>{l(content.errorText, language)}</ErrorText>

      <ButtonGrid>
        <DarkButton onClick={handleRefresh}>
          {l(content.refreshCTA, language)}
        </DarkButton>
        <LightButton onClick={handleContact}>
          {l(content.contactCTA, language)}
        </LightButton>
      </ButtonGrid>
    </ModalWrap>
  );
};

export default PaymentError;
